(function () {
   'use strict';

   var logger = new (require('../helpers/logger.js'))("AduioPlayer Initializer").setColor("#212157");
   var helper = require('../helpers/generic.js');
   var acHelper = require('../AssetCore/helper.js');
   var ACAudio = require('../AssetCore/mediaVideo.js');
   var ACClient = require('../AssetCore/client.js');
   var AudioPlayer = require('./audioplayer.js');
   var jquery = require('jquery');

   module.exports = {
     fromData: fromData,
     fromMediaOrUrl: fromMediaOrUrl
  };

  var client = null;
  function lazyInitClient(){
    if (helper.undefOrNull(client)){
      client = new ACClient();
    }
    return client;
  }

  function fromUrl(url, inline, container, options){
    var acMediaData = acHelper.generateMediaData("audio", defaultQuality, "url", url);
    acMedia = new ACAudio(acMediaData);
    return new AudioPlayer(acMedia, inline, container, options);
  }

  function fromMediaOrUrl(acMediaOrUrl, inline, container, options){
    if (inline && helper.undefOrNull(container)){
      throw "You must supply a container if you want to play the audio inline!";
    }
    if (helper.undefOrNull(acMediaOrUrl)){
      throw "Could not instantiate AudioPlayer. Data was " + acMediaOrUrl;
    }

    if (helper.undefOrNull(acMediaOrUrl.type)){
      if (typeof acMediaOrUrl == "string" && acMediaOrUrl.includes("/")){ //is not an url
        return fromUrl(acMediaOrUrl, inline, container, options);
      } else {
        throw "Only ACMedia or URLs are allowed for acMediaOrUrl; The current String is no url: " + acMediaOrUrl;
      }
    } else {
      return new AudioPlayer(acMediaOrUrl, inline, container, options);
    }
  }

  function fromData(element, options){
    var $element = $(element);

    var audioCodeOrUrl = $element.data("audio");
    var overlay = $element.data("overlay");
    var width = $element.data("width");
    var inline = helper.undefOrNull(overlay) || overlay===false || overlay==='false';
    var deferredPlayer = jquery.Deferred();

    if (helper.undefOrNull(options)){
      options = {};
    }

    if (helper.undefOrNull(options.width) && !helper.undefOrNull(width)){
      options.width = parseInt(width);
    }

    if (!helper.undefOrNull(audioCodeOrUrl)){ // load media from assetCore
      var audioMedia = lazyInitClient().getMediaPromise(audioCodeOrUrl);
      audioMedia.done(function( acAudioData ){
        var player = fromMediaOrUrl(acAudioData, inline, $element, options);
        deferredPlayer.resolve(player, acAudioData);
      }).fail(function( message ){
        deferredPlayer.reject( message );
      });
    } else {
      deferredPlayer.reject("no correct media data given");
    }

    return deferredPlayer.promise();
  }

}());



//////////////////
// WEBPACK FOOTER
// ./src/AudioPlayer/initializers.js
// module id = 26
// module chunks = 0